<template>
	<div class="">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/yz/%E5%AE%B9%E5%99%A8%20557%402x.png" class="back" @click="back" alt="" />
		<img src="https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%87%8D%E5%BA%86%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A%E5%A4%A7%E8%84%91.png" alt="" />
	</div>
</template>

<script>
	export default{
		methods:{
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	.back{
		width: 140px;
		height: 40px;
		position: fixed;
		right: 10px;
		top: 55px;
		border-radius: 10px;
		z-index: 9999;
		color: #fff;
		padding: 5px 10px;
		cursor: pointer;
		font-size: 13px;
	}
	img{
		width: 100vw;
		height: 100vh;
	}
</style>